import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

export const validateDate = (date, format = "DD/MM/YYYY") => {
  const djsDate = dayjs(date, format, true);
  return (
    djsDate.isValid() && !djsDate.isBefore("1979-01-01", "year") && !djsDate.isAfter(Date.now())
  );
};

export const validateFutureDate = (date, format = "DD/MM/YYYY") => {
  const djsDate = dayjs(date, format, true);
  return djsDate.isValid() && djsDate.isAfter(Date.now());
};

export const validateCode = (code) =>
  isNaN(code) ? /^[a-zA-Z0-9]{20}$/.test(code) : /^[0-9]{16}$/.test(code);
export const validateSapCode = (code) => /^[a-zA-Z0-9]{20}$/.test(code);
export const codeWashValidator = (code) =>
  /^(MW|JY|EP|PP|DO|EU|UI|AM|VG|PL|00)[a-zA-Z0-9]{14}$/.test(code);
export const validateProductCode = (code) => /^[0-9]{16}$/.test(code);

export const validateEmail = (email) =>
  /^([a-zA-Z0-9._-]+[a-zA-Z0-9]@[a-zA-Z0-9-]+\.[a-zA-Z.]{2,12})$/.test(email);
export const validateTel = (tel) => /^\+?[0-9.#\-()*/\s]*$/.test(tel);

export const formatDate = (evt, lastValue) => {
  const { value, selectionStart, selectionEnd } = evt.target;
  const onlyDigitsValue = value.replace(/[^\d]/g, "");
  let finalValue = onlyDigitsValue;
  if (
    value.length < lastValue.length && // One charactere deleted
    onlyDigitsValue === lastValue.replace(/[^\d]/g, "") && // Only a slash was deleted
    selectionStart === selectionEnd && // It's not a multiple character selection
    selectionEnd === value.length // The cursor is in the last position
  ) {
    finalValue = finalValue.slice(0, finalValue.length - 1);
  }
  if (finalValue.length < 2) {
    return finalValue;
  }
  const [day, month, year1, year2] = finalValue.replace(/\//g, "").match(/.{1,2}/g);
  return [day, month].concat(year1 ? [[year1, year2].filter(Boolean).join("")] : []).join("/");
};

export const validateRussianMobile = (mobileNum) =>
  /^8\((\d{3})\)(\d{3})-(\d{2})-(\d{2})$/.test(mobileNum);

// Format mobile phone like "8(_ _ _) _ _ _-_ _-_ _"
export const formatRussianMobile = (evt) => {
  const { value } = evt.target;
  let finalValue = value;
  if (!value) return value;
  if (!finalValue.startsWith("8")) {
    finalValue = "8" + finalValue;
  }
  if (finalValue.length < 2) {
    return finalValue;
  }
  if (!finalValue.startsWith("8(")) {
    finalValue = "8(" + finalValue.substring(1);
  }
  const firstBlock = finalValue.substring(2, 5);
  const firstOnlyNumbers = firstBlock.replace(/[^\d]/g, "");
  finalValue = finalValue.substring(0, 2) + firstOnlyNumbers + finalValue.substring(5);
  if (finalValue.length < 6) {
    return finalValue;
  }
  if (finalValue.substring(5, 6) !== ")") {
    finalValue = finalValue.substring(0, 5) + ")" + finalValue.substring(5);
  }
  const secondBlock = finalValue.substring(6, 9);
  const secondOnlyNumbers = secondBlock.replace(/[^\d]/g, "");
  finalValue = finalValue.substring(0, 6) + secondOnlyNumbers + finalValue.substring(9);
  if (finalValue.length < 10) {
    return finalValue;
  }
  if (finalValue.substring(9, 10) !== "-") {
    finalValue = finalValue.substring(0, 9) + "-" + finalValue.substring(9);
  }
  const thirdBlock = finalValue.substring(10, 12);
  const thirdOnlyNumbers = thirdBlock.replace(/[^\d]/g, "");
  finalValue = finalValue.substring(0, 10) + thirdOnlyNumbers + finalValue.substring(12);
  if (finalValue.length < 13) {
    return finalValue;
  }
  if (finalValue.substring(12, 13) !== "-") {
    finalValue = finalValue.substring(0, 12) + "-" + finalValue.substring(12);
  }
  const fourthBlock = finalValue.substring(13, 15);
  const fourthOnlyNumbers = fourthBlock.replace(/[^\d]/g, "");
  return finalValue.substring(0, 13) + fourthOnlyNumbers;
};
